module.exports = __webpack_public_path__ + "static/media/shop-img-2.ee216ca0.png";